import React, { useLayoutEffect } from "react";
import Providers from "../../contexts/Providers";
import { Intercom } from "@/components/Intercom";

export default function RootLayout({ children }: { children: React.ReactNode }) {
  useLayoutEffect(() => {
    if (["staging", "production"].includes(process.env.PUBLIC_STAGE)) {
      window.LogRocket?.init('4ygejv/boxem', {
        network: {
          requestSanitizer: request => {
            return {
              ...request,
              body: {
                ...request.body,
                password: null,
                repeat: null,
                xid: null,
              },
              headers: {
                ...request.headers,
                Authorization: null,
                Cookie: null,
              }
            }
          }
        }
      });
    }
  }, []);

  return (
    <Providers>
      {children}
      <Intercom />
    </Providers>
  );
}
